import classNames from 'classnames';
import * as React from 'react';
import { NavLinkProps, NavLink } from 'react-router-dom';

type Props = Pick<NavLinkProps, 'to' | 'onClick'>;

export class NavbarButton extends React.PureComponent<Props> {
  public render() {
    const { children, ...rest } = this.props;

    return (
      <div className={classNames('navbar__button')}>
        <NavLink className="link" {...rest}>{children}</NavLink>
      </div>
    );
  }
}
